import { Injectable } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';

import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, GlobalMessageType, WindowRef } from '@spartacus/core';
import { LoginFormComponentService } from '@spartacus/user/account/components';
import { Subscription } from 'rxjs';

import { Params } from '@angular/router';
import { EfaGlobalMessageService } from '@shared/services/efa-global-message.service';
import { padStart } from '../utils/login-register.utils';

const LOGIN_ERROR_KEY = 'cx_login_error';

@Injectable({
  providedIn: 'root'
})
export class EfaLoginFormComponentService extends LoginFormComponentService {
  dialogModalRef: NgbModalRef;
  subscription: Subscription = new Subscription();


  constructor(
    protected auth: AuthService,
    protected globalMessage: EfaGlobalMessageService,
    protected winRef: WindowRef,
  ) {
    super(auth, globalMessage, winRef);
    this.form.addControl('partnerId', new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(10)
    ]));
  }

  login(nativeForm?: HTMLFormElement) {
    this.form.patchValue({ username:  padStart(this.form.value.partnerId) + '_' + this.form.value.userId.toLowerCase() });
    super.login(nativeForm);
  }

  protected initCustomLogin() {
    super.initCustomLogin();
    this.form.addControl('username', new UntypedFormControl('', [Validators.required]));
  }

  handleCustomLoginError(): void {
    if (this.winRef.isBrowser()) {
      const stashed: string | null | undefined = this.winRef.sessionStorage?.getItem(LOGIN_ERROR_KEY);
      if (stashed) {
        this.winRef.sessionStorage?.removeItem(LOGIN_ERROR_KEY);
        this.clearOauthRedirectFlowFlag();
        this.globalMessage.add(
          { key: this.resolveLoginErrorKey(stashed) },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
    }
    
    // We need to override this method in order to not remove any messages that are caused by the navigation event.
    // The main reason is that currently the authorization errors received are url query parameters.
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      const error = params['error'];
      if (error) {
        this.clearOauthRedirectFlowFlag();

        if (error === 'account_disabled') {
              this.globalMessage.add({
              key: this.resolveLoginErrorKey(error),
              params: {
                href: 'mailTo:kundencenter@autoteilewelt.de',
                anchorText: 'kundencenter@autoteilewelt.de',
              },
            },
            GlobalMessageType.MSG_TYPE_ERROR
          );
        } else {
          this.globalMessage.add(
            { key: this.resolveLoginErrorKey(error) },
            GlobalMessageType.MSG_TYPE_ERROR
          );
        }
        
        this.router.navigate([], {
          queryParams: { error: null },
          state: {
            messageTypesForRemoval: []
          }
        });
      }
    });
  }
}
